<template>
  <div id="features-manage" v-if="routes">
    <div class="route">Selectane rute i feature-i će se prikazivati</div>
    <div class="route" v-for="(route, routeIndex) in routes" v-bind:key="routeIndex">
      <div v-if="route.path">
        -{{ route.path }}
        <div class="feature" v-for="(feature, featureIndex) in route.features" v-bind:key="featureIndex">
          &emsp; {{ feature.path }}
          <input type="checkbox" id="checkbox" v-model="feature.isActive" :disabled="route.isActive === false" />
        </div>
      </div>
      <span v-else>Nepoznato</span>
    </div>
    <button v-on:click="apply">Apply</button>
  </div>
</template>

<script>
export default {
  name: 'FeatureManage',
  components: {},
  data() {
    return {
      routes: [],
      isActive: true,
    };
  },
  created() {
    this.$axios.get(`${this.$API_URL}/features/all`).then(response => {
      this.routes = response.data;
    });
  },
  methods: {
    apply: function() {
      this.$axios.post(`${this.$API_URL}/features/set-routes`, this.routes).then(response => {
        if (response.status === 200) window.alert('Uspijesno postavljeno');
      });
    },
  },
};
</script>

<style scoped>
#features-manage {
  color: white;
}

.route {
  margin-bottom: 25px;
}

.route span {
  word-wrap: break-word;
  display: inline-block;
  height: auto;
  width: 12%;
  margin-right: 5px;
  vertical-align: center;
}

.routeCheckbox {
  display: inline-block;
}

.feature {
  margin-top: 2.5px;
  margin-bottom: 2.5px;
}

span:nth-child(1) {
  width: 5%;
}

button {
  padding: 6px;
}
</style>
